import React from "react";
import { Outlet } from "react-router";
import Layout from "../../layout/Layout";

const DisCounts = () => {
  return (
    <div>
      <Layout>
        <Outlet />
      </Layout>
    </div>
  );
};

export default React.memo(DisCounts);
